<template>
  <div>
    <vue-good-table
      mode="remote"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
      @on-column-filter="onColumnFilter"
      :totalRows="table.total_records"
      :isLoading.sync="table.isLoading"
      :pagination-options="{
        enabled: true,
        dropdownAllowAll: false,
        perPageDropdown: [10, 25, 50, 100],
      }"
      :columns="table.columns"
      :rows="table.rows"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'name'">
          <i class="fas fa-envelope text-muted mr-2"></i>
          {{ props.row.name }}
        </span>
        <span v-else-if="props.column.field === 'type_id'">
          <span class="badge badge-light text-uppercase">{{ props.row.type_id }}</span>
        </span>
        <span v-else-if="props.column.field === 'channels'">
          <span class="badge badge-info"><i class="fas fa-envelope mr-1"></i> EMAIL</span>
        </span>
        <span v-else-if="props.column.field === 'trigger'">
          <span class="badge badge-warning text-dark">
            <i class="far fa-clock mr-1"></i> {{ triggerLabel(props.row) }}
          </span>
        </span>
        <span v-else-if="props.column.field === 'status'">
          <span :class="props.row.status === 'active' ? 'text-success' : 'text-muted'">
            {{ props.row.status === 'active' ? 'ACTIVE' : 'INACTIVE' }}
          </span>
        </span>
        <span v-else-if="props.column.field === 'action'">
          <span class="table-actions">
            <button type="button" class="btn btn-sm btn-primary text-white" @click="$root.$emit('open_email_blast', props.row)">
              Blast
            </button>
            <router-link :to="'/admin/email-template/edit?id=' + props.row.id" class="btn btn-sm btn-primary text-white">
              Edit
            </router-link>
            <button type="button" class="btn btn-sm btn-danger text-white" @click="deleteTemplate(props.row.id)">
              Hapus
            </button>
          </span>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table: {
        total_records: 0,
        isLoading: true,
        columns: [
          { label: 'TEMPLATE NAME', field: 'name', filterOptions: { enabled: true }, sortable: false, width: '18%' },
          { label: 'TYPE ID', field: 'type_id', filterOptions: { enabled: true }, sortable: false, width: '14%' },
          { label: 'SUBJECT LINE', field: 'subject', filterOptions: { enabled: true }, sortable: false, width: '24%' },
          { label: 'CHANNELS', field: 'channels', sortable: false, width: '10%' },
          { label: 'TRIGGER', field: 'trigger', sortable: false, width: '16%' },
          { label: 'STATUS', field: 'status', filterOptions: { enabled: true }, sortable: false, width: '8%' },
          { label: 'ACTIONS', field: 'action', sortable: false, width: '14%' },
        ],
        rows: [],
        serverParams: {
          columnFilters: {},
          page: 1,
          limit: 10,
        },
      },
    }
  },
  mounted() {
    this.fn = () => this.loadItems()
    this.$root.$on('refresh_email_template_table', this.fn)
    this.loadItems()
  },
  beforeDestroy() {
    this.$root.$off('refresh_email_template_table', this.fn)
  },
  methods: {
    triggerLabel(row) {
      const map = {
        days_before_expired: `${row.trigger_days} HARI SEBELUM EXPIRED`,
        on_expired: 'SAAT EXPIRED',
        days_after_expired: row.trigger_days === 7 ? 'HAPUS SETELAH 7 HARI' : `${row.trigger_days} HARI SETELAH EXPIRED`,
        on_reset_password: 'SAAT RESET PASSWORD',
        manual: 'MANUAL / BLAST',
      }
      return map[row.trigger_type] || row.trigger_type
    },
    updateParams(newProps) {
      this.table.serverParams = Object.assign({}, this.table.serverParams, newProps)
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ limit: params.currentPerPage, page: 1 })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams({ columnFilters: params.columnFilters, page: 1 })
      this.loadItems()
    },
    async loadItems() {
      this.table.isLoading = true
      try {
        const response = await this.$store.dispatch('admin_email_template_list', {
          page: this.table.serverParams.page,
          limit: this.table.serverParams.limit,
          columnFilters: JSON.stringify(this.table.serverParams.columnFilters),
        })
        this.table.rows = response.data.data.templates
        this.table.total_records = response.data.data.total_records
      } catch (err) {
        this.$toast.error(err.response?.data?.message || 'Gagal memuat template email')
      }
      this.table.isLoading = false
    },
    async deleteTemplate(id) {
      const ok = await this.$confirm({
        title: 'Hapus Template',
        message: 'Yakin ingin menghapus template email ini?',
        confirmText: 'Hapus',
      })
      if (!ok) return
      try {
        const response = await this.$store.dispatch('admin_email_template_delete', id)
        this.$toast.success(response.data.message)
        this.loadItems()
      } catch (err) {
        this.$toast.error(err.response?.data?.message || 'Gagal menghapus template')
      }
    },
  },
}
</script>
